import { Component, OnInit } from '@angular/core';
import { Table } from 'primeng/table';
import { MonitoramentoSuporte } from 'src/app/admihair/api/dto/monitoramento-suporte';
import { ChamadoSuporteService } from 'src/app/admihair/service/chamado-suporte.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { GraficoBarraSimplificado } from 'src/app/admihair/api/dto/grafica-barra-simplificado';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { MonitoramentoSuporteGraficoPizza } from 'src/app/admihair/api/dto/monitoramento-suporte-grafico-pizza';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';

import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from 'chart.js';
import { forkJoin } from 'rxjs';
Chart.register(ChartDataLabels);

@Component({
    selector: 'app-monitoramento',
    templateUrl: './monitoramento.component.html',
    styleUrls: ['./monitoramento.component.scss']
})
export class MonitoramentoComponent extends AdmihairBaseComponent implements OnInit {

    knobValue: number = 90;
    barData: any;
    barOptions: any;
    pieData: any;
    pieOptions: any;

    pluginGraficos: any;

    monitoramento?: MonitoramentoSuporte;
    monitoramentoGraficoPizza: MonitoramentoSuporteGraficoPizza[] = [];
    monitoramentoGraficoBarra: GraficoBarraSimplificado[] = [];

    listaChamados: ChamadoSuporte[] = [];

    filtroGraficoBarraSelecionado: number = 7;

    filtroGraficoPizza: SelectItem[] = [
        { label: 'Hoje', value: 0 },
        { label: '7 dias', value: 7 },
        { label: '30 dias', value: 30 },
        { label: '90 dias', value: 90 },
        { label: 'Todos', value: 99 }
    ];
    filtroGraficoPizzaSelecionado: number = 0;

    loading: boolean = false;
    loadingGraficosPrimeiraVez: boolean = true;

    itensPaginados?: Paginador<ChamadoSuporte>;
    numeroPagina: number = 0;
    inputBusca?: string = '';
    ordenacao: string = 'dataCriacao,DESC';
    tamanhoPagina: number = 10;

    listaStatus: SelectItem[] = [
        { label: 'TODOS', value: 'TODOS' },
        { label: 'ABERTOS', value: 'ABERTO' },
        { label: 'RECEBIDOS', value: 'RECEBIDO' },
        { label: 'EM ATENDIMENTO', value: 'EM_ATENDIMENTO' },
        { label: 'ENCERRADOS', value: 'ENCERRADO' }
    ]
    statusSelecionado: string = 'ABERTO';

    listaFiltroSolicitado: SelectItem[] = [
    { label: 'Recebido', value: 'FRANQUIA' },
    { label: 'Enviado', value: 'EMPRESA' }
  ];
    solicitadoSelecionado: string = 'FRANQUIA';

    listaTiposAtendimento: SelectItem[] = [
        { label: 'TODOS', value: 'TODOS' },
        { label: 'ERRO', value: 'ERRO' },
        { label: 'DÚVIDA', value: 'DUVIDA' },
        { label: 'SOLICITAÇÃO DE FUNCIONALIDADE', value: 'SOLICITACAO_FUNCIONALIDADE' },
        { label: 'PROBLEMA DE DESEMPENHO', value: 'PROBLEMA_DESEMPENHO' },
        { label: 'ACESSO/PERMISSÃO', value: 'ACESSO_PERMISSAO' },
        { label: 'TREINAMENTO/CAPACITAÇÃO', value: 'TREINAMENTO_CAPACITACAO' },
        { label: 'INSTALACÃO/CONFIGURAÇÃO', value: 'INSTALACAO_CONFIGURACAO' },
        { label: 'SOLICITAÇÃO DE DOCUMENTO', value: 'SOLICITACAO_DOCUMENTO' },
        { label: 'SOLICITAÇÃO DE INFORMAÇÕES COMPLEMENTARES', value: 'SOLICITACAO_INFORMACOES_COMPLEMENTARES' },
        { label: 'OUTRO', value: 'OUTRO' },
    ]
    tipoAtendimentoSelecionado: string = 'TODOS';


    mediaAvaliacaoArredonda: number = 0;
    mediaAvaliacao: number = 0;

    private intervaloAtualizacao: any;
    private intervaloTimeout: number = 600000;
    //private intervaloTimeout: number = 10000;

    constructor(private chamadoSuporteService: ChamadoSuporteService,
        erroService: ErroService,
        storageService: UtilStorageService,
        router?: Router,
        activatedRoute?: ActivatedRoute) {
        super(erroService, storageService, router, activatedRoute);

    }

    ngOnInit(): void {
        this.setExibirSpinnerPrincipal(true);
        this.carregarMonitoramentoCards();

        this.intervaloAtualizacao = setInterval(() => {
            this.atualizacaoRecorrenteDados();
        }, this.intervaloTimeout);

    }

    ngOnDestroy(): void {
        if (this.intervaloAtualizacao) {
            clearInterval(this.intervaloAtualizacao);
        }
    }


    atualizacaoRecorrenteDados() {
        this.filtroGraficoPizzaSelecionado = 0;
        this.statusSelecionado = 'ABERTO';
        this.solicitadoSelecionado = 'FRANQUIA';
        this.tipoAtendimentoSelecionado = 'TODOS';
        this.carregarMonitoramentoCards();
        this.carregarChamados();
    }

    carregarMonitoramentoCards() {
        this.chamadoSuporteService.obterMonitoramentoPorAdministradoraId(
            this.getAdministradora().id
        ).subscribe({
            next: (data: MonitoramentoSuporte) => {
                this.monitoramento = data;
                this.obterMediaAvaliacao();
            },
            error: (err: any) => {
                this.setExibirSpinnerPrincipal(false);
                this.exibirMensagemErro(err);
            }
        })
    }

    obterMediaAvaliacao() {
        this.chamadoSuporteService.obterMediaAvaliacaoFranquia(
            this.getAdministradora().id
        ).subscribe({
            next: (data: number) => {
                this.mediaAvaliacao = data;
                this.mediaAvaliacaoArredonda = Math.floor(this.mediaAvaliacao);
                this.carregarGraficos();
                this.setExibirSpinnerPrincipal(false);
            },
            error: (err: any) => {
                this.setExibirSpinnerPrincipal(false);
                this.exibirMensagemErro(err);
            }
        })
    }

    carregarGraficos() {
        forkJoin({
            graficoBarra: this.chamadoSuporteService.obterChamadosEncerradosPorPeriodoDias(
                this.getAdministradora().id,
                this.filtroGraficoBarraSelecionado
            ),
            graficoPizza: this.chamadoSuporteService.obterMonitoramentoGraficoPizzaPorAdministradoraId(
                this.getAdministradora().id,
                this.filtroGraficoPizzaSelecionado
            )
        }).subscribe({
            next: ({ graficoBarra, graficoPizza }) => {
                this.monitoramentoGraficoBarra = graficoBarra;
                this.processarGraficoBarra(graficoBarra);

                this.monitoramentoGraficoPizza = graficoPizza;
                this.processarGraficoPizza();
                this.loadingGraficosPrimeiraVez = false;
            },
            error: (err) => {
                this.exibirMensagemErro(err);
                this.loadingGraficosPrimeiraVez = false;
            }
        });
    }

    carregarGraficoEncerrados() {
        this.chamadoSuporteService.obterChamadosEncerradosPorPeriodoDias(
            this.getAdministradora().id,
            this.filtroGraficoBarraSelecionado
        ).subscribe({
            next: (data: GraficoBarraSimplificado[]) => {
                this.monitoramentoGraficoBarra = data;
                this.processarGraficoBarra(data);
            },
            error: (err: any) => {
                this.exibirMensagemErro(err);
            }
        })
    }

    carregarMonitoramentoGraficoPizza() {
        this.chamadoSuporteService.obterMonitoramentoGraficoPizzaPorAdministradoraId(
            this.getAdministradora().id,
            this.filtroGraficoPizzaSelecionado
        ).subscribe({
            next: (data: MonitoramentoSuporteGraficoPizza[]) => {
                this.monitoramentoGraficoPizza = data;
                this.processarGraficoPizza();
            },
            error: (err: any) => {
                this.exibirMensagemErro(err);
            }
        })
    }

    carregarChamados() {
        this.loading = true;
        this.chamadoSuporteService.listarPorAdministradora(
            this.getAdministradora().id,
            this.numeroPagina,
            this.tamanhoPagina,
            this.ordenacao,
            this.inputBusca,
            this.statusSelecionado,
            this.solicitadoSelecionado,
            this.tipoAtendimentoSelecionado
        ).subscribe({
            next: (data: Paginador<ChamadoSuporte>) => {
                this.itensPaginados = data;
                this.listaChamados = data.content;
                this.loading = false;
            },
            error: (err: any) => {
                this.loading = false;
                this.exibirMensagemErro(err);
            }
        })
    }

    alterarFiltro(table: Table) {
        table.clear();
    }

    onLazyLoad(event: LazyLoadEvent) {
        if (event.first !== undefined && event.rows !== undefined) {
            if (event.first === 0 && event.rows === 0) {
                this.numeroPagina = 0;
            } else {
                this.numeroPagina = event.first / event.rows;
            }
        }
        this.definirOrdenacao(event.sortField, event.sortOrder);
        this.loading = true;
        this.carregarChamados();
    }

    definirOrdenacao(sortField?: string, sortOrder?: number) {
        if (sortField && sortOrder) {
            const campoDeOrdenacao = sortField ? sortField : 'dataCriacao';
            const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
            this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
        } else {
            this.ordenacao = 'dataCriacao,DESC';
        }
    }

    buscar(table: Table, event: Event) {
        this.inputBusca = (event.target as HTMLInputElement).value;
        this.numeroPagina = 0;
        table.clear();
    }

    limpar(table: Table) {
        this.inputBusca = '';
        this.statusSelecionado = 'ABERTO'
        table.reset();
    }

    processarGraficoBarra(lista: GraficoBarraSimplificado[]) {

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        let labelsTitulos: string[] = [];
        let dataset: number[] = [];

        console.log(lista)

        for (const item of lista) {
            labelsTitulos.push(item.texto!);
            dataset.push(Number.parseInt(item.valor!));
        }

        this.barData = {
            labels: labelsTitulos,
            datasets: [
                {
                    label: 'Chamado Encerrados',
                    data: dataset,
                    backgroundColor: documentStyle.getPropertyValue('--primary-500'),
                    barThickness: 30,
                    borderRadius: 5,
                }
            ]
        };

        this.barOptions = {
            animation: {
                duration: 1000
            },
            layout: {
                padding: {
                    top: 20
                }
            },
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                        usePointStyle: true,
                        font: {
                            weight: 700,
                        },
                        padding: 28
                    },
                    position: 'bottom',
                    display: false
                },
                datalabels: {
                    color: '#000000',
                    font: {
                        weight: 'bold',
                        size: 14
                    },
                    formatter: (value: any, context: any) => {
                        return value; // ou formate como quiser
                    },
                    anchor: 'end',
                    align: 'end',
                    offset: 2
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: {
                            weight: 500
                        }
                    },
                    grid: {
                        display: false,
                        drawBorder: false
                    }
                },
                y: {
                    ticks: {
                        color: textColorSecondary,
                        callback: function (value: any) {
                            if (Number.isInteger(value)) {
                                return value;
                            }
                            return null;
                        }
                    },
                    grid: {
                        color: surfaceBorder,
                        drawBorder: false
                    }
                }
            }
        };

        this.pluginGraficos = [ChartDataLabels];

    }


    processarGraficoPizza() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');

        this.pieData = {
            labels: this.monitoramentoGraficoPizza.map(item => item.tipoFormatado),
            datasets: [
                {
                    data: this.monitoramentoGraficoPizza.map(item => item.quantidade),
                    backgroundColor: [
                        documentStyle.getPropertyValue('--primary-700'),
                        documentStyle.getPropertyValue('--primary-400'),
                        documentStyle.getPropertyValue('--primary-100'),
                        documentStyle.getPropertyValue('--green-400')
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--primary-600'),
                        documentStyle.getPropertyValue('--primary-300'),
                        documentStyle.getPropertyValue('--primary-200'),
                        documentStyle.getPropertyValue('--green-300')
                    ]
                }
            ]
        };

        this.pieOptions = {
            animation: {
                duration: 1000
            },
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                        usePointStyle: true,
                        font: {
                            weight: 700,
                            size: 13
                        },
                        padding: 28
                    },
                    position: 'bottom'
                },
                datalabels: {
                    color: '#FFFFFF',
                    font: {
                        weight: 'bold',
                        size: 14
                    },
                    formatter: (value: any, context: any) => {
                        return value; // ou formate como quiser
                    }
                }

            }
        };

        this.pluginGraficos = [ChartDataLabels];
    }

    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }

}
